/**
 * Utilitários para funcionalidades sociais do footer
 * Adaptado das funções do BetaAccessPopup para uso no footer
 */

/**
 * Função para compartilhar usando Web Share API com fallback para clipboard
 */
export const handleShare = async () => {
  const shareData = {
    title: 'Gabriela',
    text: 'Descobri a Gabriela! A solução completa de gestão para consultórios!',
    url: 'https://www.gabriela.app.br'
  };

  try {
    if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
      await navigator.share(shareData);
    } else {
      // Fallback para clipboard
      await navigator.clipboard.writeText(`${shareData.text} ${shareData.url}`);
      // Aqui poderia mostrar um toast de confirmação
    }
  } catch (error) {
    // Fallback manual
    try {
      await navigator.clipboard.writeText(`${shareData.text} ${shareData.url}`);
    } catch {}
  }
};
